import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["uplineRadio", "downlineCheckbox", "downlineSection", "uplineIdField"]
    static values = {
        selectedUplineId: Number,
        addDownlineUrl: { type: String, default: "/permissions/add_downline" },
        removeDownlineUrl: { type: String, default: "/permissions/remove_downline" }
    }

    connect() {
    }

    selectUpline(event) {
        this.selectedUplineIdValue = parseInt(event.target.value)

        // Update the hidden field in the downline search form
        if (this.hasUplineIdFieldTarget) {
            this.uplineIdFieldTarget.value = this.selectedUplineIdValue
        }

        // Reload the downline turbo frame with the selected upline
        this.reloadDownlineFrame()

        window.scrollTo({
            top: 320,
            left: 0,
            behavior: "smooth"
        })
    }

    reloadDownlineFrame() {
        const downlineFrame = document.querySelector('turbo-frame#downline_results')
        if (downlineFrame) {
            // Build URL with selected_upline_id param
            const url = new URL(window.location.href)
            url.searchParams.set('selected_upline_id', this.selectedUplineIdValue)

            // Reload the turbo frame with the new URL
            downlineFrame.src = url.toString()
        }
    }

    async toggleDownline(event) {
        const checkbox = event.target
        const downlineId = checkbox.dataset.downlineId
        const isChecked = checkbox.checked

        if (!this.selectedUplineIdValue) {
            checkbox.checked = false
            this.showNotification("Please select an upline first", "warning")
            return
        }

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

        try {
            const url = isChecked ? this.addDownlineUrlValue : this.removeDownlineUrlValue
            const method = isChecked ? "POST" : "DELETE"

            const response = await fetch(url, {
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": csrfToken,
                    "Accept": "text/vnd.turbo-stream.html, application/json"
                },
                body: JSON.stringify({
                    upline_id: this.selectedUplineIdValue,
                    downline_id: downlineId
                })
            })

            if (response.ok) {
                const message = isChecked ? "Downline added" : "Downline removed"
                this.showNotification(message, "success")
            } else {
                // Revert checkbox state on error
                checkbox.checked = !isChecked
                const data = await response.json()
                this.showNotification(data.message || "Operation failed", "error")
            }
        } catch (error) {
            // Revert checkbox state on error
            checkbox.checked = !isChecked
            this.showNotification("Network error occurred", "error")
            console.error("Error:", error)
        }
    }

    showNotification(message, type = "info") {
        // Update the notification message
        const toastElement = document.querySelector('[data-controller="toast"]')
        if (toastElement) {
            const messageSpan = toastElement.querySelector('[data-toast-target="message"]')
            if (messageSpan) {
                messageSpan.textContent = message
            }
        }

        // Dispatch event to show the notification
        const event = new CustomEvent("permissions:notification")
        window.dispatchEvent(event)
    }

    clearForm(event) {
        event.preventDefault()

        // Find the form that contains the clicked button
        const form = event.target.closest('form')
        if (!form) return

        // Preserve the selected upline ID before resetting
        const uplineIdField = form.querySelector('[data-permissions-target="uplineIdField"]')
        const uplineIdValue = uplineIdField?.value

        // Reset all form inputs
        form.reset()

        // Restore the selected upline ID
        if (uplineIdField && uplineIdValue) {
            uplineIdField.value = uplineIdValue
        }

        // Clear any slim-select elements
        form.querySelectorAll('[data-controller="slim"]').forEach(el => {
            const slimInstance = el.slim
            if (slimInstance) {
                slimInstance.setSelected([])
            }
        })

        // Submit the cleared form to refresh results
        form.requestSubmit()
    }
}